export const ADMIN_LOGIN = "ADMIN_AUTH";
export const LOGOUT = "LOGOUT";
export const UPDATE_PASSWORD = "UPDATE_PASSWORD";
export const UPDATE_ADMIN = "UPDATE_ADMIN";
export const ADD_ADMIN = "ADD_ADMIN";
export const ADD_DEPARTMENT = "ADD_DEPARTMENT";
export const ADD_FACULTY = "ADD_FACULTY";
export const GET_ALL_FACULTY = "GET_ALL_FACULTY";
export const ADD_SUBJECT = "ADD_SUBJECT";
export const GET_ALL_SUBJECT = "GET_ALL_SUBJECT";
export const ADD_STUDENT = "ADD_STUDENT";
export const ADD_ONE_STUDENT = "ADD_STUDENT";
export const GET_ALL_STUDENT = "GET_ALL_STUDENT";
export const GET_ALLL_STUDENT = "GET_ALL_STUDENT";
export const GET_STUDENT = "GET_STUDENT";
export const GET_ONE_STUDENT = "GET_STUDENT";
export const GET_FACULTY = "GET_FACULTY";
export const GET_SUBJECT = "GET_SUBJECT";
export const GET_ALL_ADMIN = "GET_ALL_ADMIN";
export const GET_ALL_DEPARTMENT = "GET_ALL_DEPARTMENT";
export const SET_ERRORS = "SET_ERRORS";
export const FACULTY_LOGIN = "FACULTY_LOGIN";
export const UPDATE_FACULTY = "UPDATE_FACULTY";
export const ADD_TEST = "ADD_TEST";
export const GET_TEST = "GET_TEST";
export const MARKS_UPLOADED = "MARKS_UPLOADED";
export const ATTENDANCE_MARKED = "ATTENDANCE_MARKED";
export const STUDENT_LOGIN = "STUDENT_LOGIN";
export const UPDATE_STUDENT = "UPDATE_STUDENT";
export const TEST_RESULT = "TEST_RESULT";
export const ATTENDANCE = "ATTENDANCE";
export const GET_ADMIN = "GET_ADMIN";
export const DELETE_ADMIN = "DELETE_ADMIN";
export const DELETE_DEPARTMENT = "DELETE_DEPARTMENT";
export const DELETE_FACULTY = "DELETE_FACULTY";
export const DELETE_STUDENT = "DELETE_STUDENT";
export const DELETE_ONE_STUDENT = "DELETE_STUDENT";
export const DELETE_SUBJECT = "DELETE_SUBJECT";
export const CREATE_NOTICE = "CREATE_NOTICE";
export const GET_NOTICE = "GET_NOTICE";
